/** Footer navigation — layout matches Rock Health Capital (rockhealthcapital.com). */

export const FOOTER_SUBSCRIBE = {
  label: "Subscribe",
  to: "/signup",
};

/** Primary vertical nav (left column) */
export const FOOTER_NAV = [
  { label: "Sign in", to: "/login" },
  { label: "Job Board", section: "opportunities" },
  { label: "Insights", section: "insights" },
  { label: "About Us", section: "mission" },
  { label: "Open account", to: "/signup" },
  { label: "Privacy Policy", section: "mission" },
];

/**
 * Social links. Only ``enabled: true`` items render in the footer.
 * Keep disabled entries for later (Twitter/X, SoundCloud, YouTube, etc.).
 * Update hrefs to the live company profiles / WhatsApp number when ready.
 */
export const FOOTER_SOCIAL = [
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/",
    icon: "linkedin",
    enabled: true,
  },
  {
    label: "Facebook",
    href: "https://www.facebook.com/",
    icon: "facebook",
    enabled: true,
  },
  {
    label: "WhatsApp",
    href: "https://wa.me/",
    icon: "whatsapp",
    enabled: true,
  },
  {
    label: "X (Twitter)",
    href: "https://twitter.com/",
    icon: "twitter",
    enabled: false,
  },
  {
    label: "SoundCloud",
    href: "https://soundcloud.com/",
    icon: "soundcloud",
    enabled: false,
  },
  {
    label: "YouTube",
    href: "https://www.youtube.com/",
    icon: "youtube",
    enabled: false,
  },
];

/** Currently active social icons for the marketing footer. */
export const FOOTER_SOCIAL_ACTIVE = FOOTER_SOCIAL.filter((item) => item.enabled);

/** Green brand bar at the very bottom */
export const FOOTER_BRAND_BAR = [
  { label: "Advisory", section: "mission" },
  { label: "Capital", to: "/" },
  { label: "NeedHealth.Care", href: "https://needhealth.care/", external: true },
];
